/* 公共引入,勿随意修改,修改时需经过确认 */
import Vue from 'vue'
import './element'
import './hotent'
import './prototype'
import '@/styles/base.scss'
import '@/styles/base-element.scss'
import Global from '@/utils/global'

Vue.use(Global)
